import React from 'react';
import { motion } from 'framer-motion';
import { assets, contactEmail } from '../../data/assets';
import { footerLinks, legalLinks } from '../../data/navigation';
import { LinkButton } from '../LinkButton';
import { SocialLinks } from '../SocialLinks';
import { SplitText } from '../SplitText';
import { FollowCursorButton } from './FollowCursorButton';
const linkList = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const linkItem = {
  hidden: {
    opacity: 0,
    y: '100%'
  },
  show: {
    opacity: 1,
    y: '0%',
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-white px-5 pb-[1.875rem] pt-[5rem] md:px-10 md:pt-[7.625rem] lg:pb-[3.75rem] lg:pt-[9.375rem]" data-id="element-94" data-mp="1w7scdsh63nz7">
      <div className="mx-auto grid max-w-[71.875rem] grid-cols-1 gap-y-20 lg:grid-cols-[1.25fr_1fr] lg:gap-x-[10.875rem] lg:gap-y-[6.25rem]" data-id="element-95" data-mp="13p4xiusrl56k">
        <div className="flex flex-col items-start" data-id="element-96" data-mp="yq22m36i0fcb">
          <SplitText as="h2" text={"Ready to scale?\nLet's have a chat!"} className="w-[17.5rem] text-[2rem] font-medium leading-[1.5] tracking-[0.47px] sm:w-auto md:tracking-[0.7px] md:w-[33.5rem] md:text-[3.8125rem]" data-id="element-97" data-mp="1eiltow6fqrwx" />
          <div className="mt-[1.563rem] md:mt-[1.875rem] lg:mt-10" data-id="element-98" data-mp="1ncgwvynzy89x">
            <FollowCursorButton label="Get in touch" href={`mailto:${contactEmail}`} data-id="element-99" data-mp="1s85tpu8mtb2j" />
          </div>
        </div>

        <nav aria-label="Footer" data-id="element-100" data-mp="vl12hig77h95">
          <p className="mb-[1.5625rem] text-[1.25rem] font-medium leading-[1.5] tracking-[0.01em] lg:mb-10 lg:mt-[0.625rem]" data-id="element-101" data-mp="zkjn0d43xqbg">Nav</p>
          <motion.ul variants={linkList} initial="hidden" whileInView="show" viewport={{
          once: true,
          amount: 0.3
        }} className="grid w-[17.5rem] grid-cols-[max-content_max-content] gap-x-20 gap-y-[1.81rem] sm:w-auto md:gap-y-9 lg:w-full lg:justify-between lg:gap-x-9" data-id="element-102" data-mp="14iuwgmqhpyt5">
            {footerLinks.map(link => <motion.li key={link.label} variants={linkItem} data-id="element-103" data-mp="1v9h8jzxoblnm">
                <LinkButton label={link.label} href={link.href} variant="footer" external={link.external} data-id="element-104" data-mp="1vbtsujqwm83u" />
              </motion.li>)}
          </motion.ul>
        </nav>

        <div className="flex flex-col justify-end gap-[0.938rem] sm:gap-[1.125rem]" data-id="element-105" data-mp="257ex6ojg3kgr">
          <p className="text-[0.875rem] font-medium leading-[1.36] tracking-[0.01em] text-black" data-id="element-106" data-mp="209muczh9idxs">Follow us on</p>
          <SocialLinks variant="footer" data-id="element-107" data-mp="1cjsncyjmjjlg" />
        </div>

        <div className="flex flex-col justify-end gap-[0.938rem] sm:gap-[1.125rem]" data-id="element-108" data-mp="17l7k0q92sjss">
          <p className="text-[0.875rem] font-medium leading-[1.36] tracking-[0.01em] text-black" data-id="element-109" data-mp="1m9u9vlwbwty9">Business email</p>
          <div data-id="element-110" data-mp="1hicav3dv93fx">
            <LinkButton label={contactEmail} href={`mailto:${contactEmail}`} variant="email" data-id="element-111" data-mp="1hhu4vf1ejaut" />
          </div>
        </div>

        <div className="flex flex-col gap-6 md:gap-8 lg:col-span-2 lg:flex-row lg:items-center lg:justify-between" data-id="element-112" data-mp="tqx0qofulhu4">
          <div className="flex flex-wrap items-center gap-x-16 gap-y-2" data-id="element-113" data-mp="os3v1i6syv4i">
            <a href="#top" aria-label="Back to top" className="group relative hidden items-center justify-center lg:flex" data-id="element-114" data-mp="30fz31n29qre5">
              <img src={assets.footerLogo} alt="" className="h-8 w-auto" data-id="element-115" data-mp="359tfc5fjo437" />
              <img src={assets.logo3d} alt="" aria-hidden="true" className="pointer-events-none absolute min-w-[280%] scale-[0.96] opacity-0 transition-[transform,opacity] duration-200 ease-out group-hover:scale-100 group-hover:opacity-100" data-id="element-116" data-mp="2qkxasicp597c" />
            </a>
            <p className="text-[0.813rem] font-medium leading-[1.36] tracking-[0.01em] text-black/50 sm:text-[0.875rem]" data-id="element-117" data-mp="3a7d6u7196dd3">
              © {year} Immersive Studios. All rights reserved.
            </p>
          </div>
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 md:gap-x-[1.875rem]" data-id="element-118" data-mp="1yrepzgzu2n1b">
            {legalLinks.map(link => <li key={link.label} data-id="element-119" data-mp="22v2zi580zsp7">
                <a href={link.href} className="text-[0.813rem] font-medium leading-[1.36] tracking-[0.01em] text-black/50 transition-colors duration-200 hover:text-black sm:text-[0.875rem]" data-id="element-120" data-mp="2j0o1fip92vyr">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}